export const DURACAO_SLOT_MIN = 30;

export function minutosDoHorario(hhmm: string): number {
  const [horas, minutos] = hhmm.split(':').map(Number);
  return (horas ?? 0) * 60 + (minutos ?? 0);
}

export function horarioDosMinutos(minutos: number): string {
  const horas = Math.floor(minutos / 60);
  const minutosRestantes = minutos % 60;
  return `${String(horas).padStart(2, '0')}:${String(minutosRestantes).padStart(2, '0')}`;
}

export function janelaDeAtendimentoValida(horarioInicial: string, horarioFinal: string): boolean {
  return minutosDoHorario(horarioFinal) > minutosDoHorario(horarioInicial);
}

/** Usa o mesmo intervalo semiaberto `[início, fim)` no client e no servidor. */
export function horarioDentroDaJanela(
  horario: string,
  horarioInicial: string,
  horarioFinal: string,
): boolean {
  const minutos = minutosDoHorario(horario);
  return minutos >= minutosDoHorario(horarioInicial) && minutos < minutosDoHorario(horarioFinal);
}
